import React from "react";
import "./_club-tile.scss";
import {ClubType} from "../../../../types/ApiTypeDefinition/clubFinderResultTypes";
import {Config} from "../../../../constants/Config";

interface ClubTilePropType {
  clubDetails: ClubType
  clubTileContainerStyles?: string
  index: any
  handleClubTileAction?: any
  clubLogoVisible?: boolean
  tenant: string|undefined
  contentScrolledHeight?: number
}

const ClubTile = (props: ClubTilePropType): JSX.Element => {
  let clubAddressText = ''
  if (props.clubDetails.address) {
    clubAddressText = `${props.clubDetails.address.line1 ? `${props.clubDetails.address.line1},` : ''}${props.clubDetails.address.suburb ? ` ${props.clubDetails.address.suburb}` : ''}${props.clubDetails.address.state ? `, ${props.clubDetails.address.state}` : ''}`
  }
  let clubLogoUrlEnhanced = props.clubDetails.orgLogo;
  if(props.clubDetails.orgLogo) {
    clubLogoUrlEnhanced = props.clubDetails.orgLogo.replace('h_32', 'h_64');
    clubLogoUrlEnhanced = clubLogoUrlEnhanced.replace('w_32', 'w_64');
  }
  return (
    <div className={['clubTileContainer-version-2', props.contentScrolledHeight && props.contentScrolledHeight > 15 ? 'shadow' : ''  , props.tenant, props.clubTileContainerStyles].join(' ')} key={props.index} onClick={() => props.handleClubTileAction(props.clubDetails.orgId, props.clubDetails.distance)}>
      <div className={'clubDetailsCol'}>
        <div className={'club-details-header'}>
          Association / club
        </div>
        {props.clubDetails.orgName && (
          <div className={'clubName'}>{props.clubDetails.orgName}</div>
        )}
        {props.clubDetails.distance && props.tenant == Config.tenantList.naTenant && (
          <div
            className={'distanceText'}>{Math.round((parseFloat(props.clubDetails.distance) + Number.EPSILON) * 100) / 100} KM
          </div>
        )}
        {props.clubDetails.address && (
          <div
            className={'clubAddress'}>{clubAddressText}</div>
        )}
      </div>
      {props.clubDetails.distance && props.tenant == Config.tenantList.aflTenant && (
        <div
          className={'distanceText'}>{Math.round((parseFloat(props.clubDetails.distance) + Number.EPSILON) * 100) / 100} KM
        </div>
      )}
      {props.clubLogoVisible && props.clubDetails.orgLogo && (
        <div className={'clubLogoContainer'}>
          {props.clubDetails.orgLogo && (
            <img src={clubLogoUrlEnhanced} className={'clubLogoImage'} alt="logo"/>
          )}
        </div>
      )}
    </div>
  )
}

export default ClubTile;
